import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import "../App.css";

import { signOut } from "firebase/auth";
import {
  doc,
  getDoc,
  collection,
  query,
  where,
  onSnapshot,
} from "firebase/firestore";

import { auth, db } from "../firebase";

function Profile() {
  const [userData, setUserData] = useState(null);
  const [depositHistory, setDepositHistory] = useState([]);
const [withdrawHistory, setWithdrawHistory] = useState([]);

useEffect(() => {
  const loadUser = async () => {
    const user = auth.currentUser;
    alert(auth.currentUser?.uid);
    console.log("Admin UID:", user?.uid);
console.log("Admin Email:", user?.email);


    if (!user) return;

    try {
      const snap = await getDoc(doc(db, "users", user.uid));

      if (snap.exists()) {
        setUserData(snap.data());
      }
    } catch (error) {
      console.error(error);
    }
  };

  loadUser();
}, []);
  const logoutUser = async () => {
  try {
    await signOut(auth);
    window.location.href = "/login";
  } catch (error) {
    console.error(error);
    alert("Logout failed");
  }
};
  return (
    <div className="app profile-page">
      <header className="page-header">
        <Link to="/dashboard" className="back-button">
          ←
        </Link>

        <div>
          <h1>My Profile</h1>
          <p>Manage your account and history</p>
        </div>
      </header>

      <section className="profile-hero-card">
        <div className="profile-avatar">👤</div>

        <div className="profile-main-info">
          <h2>{userData?.name || "Loading..."}</h2>
         
          <p>User ID: ST123456</p>
          <span>Standard Member</span>
        </div>

        <button type="button" className="edit-profile-button">
          Edit
        </button>
      </section>

      <section className="profile-balance-card">
        <div>
          <span>Available Balance</span>
         <h2>${userData?.balance || 0}</h2>
        </div>

        <Link to="/deposit" className="profile-deposit-button">
          Deposit
        </Link>
      </section>

      <section className="profile-stats-grid">
        <div className="profile-stat-card">
          <span>Total Deposit</span>
         <strong>${userData?.totalDeposit || 0}</strong>
        </div>

        <div className="profile-stat-card">
          <span>Total Profit</span>
         <strong>${userData?.totalProfit || 0}</strong>
        </div>

        <div className="profile-stat-card">
          <span>Total Withdraw</span>
         <strong>${userData?.totalWithdraw || 0}</strong>
        </div>

        <div className="profile-stat-card">
          <span>Referral Income</span>
          <strong>${userData?.referralCommission || 0}</strong>
        </div>
      </section>

      <section className="profile-card">
        <div className="profile-section-title">
          <h2>Personal Information</h2>
        </div>

        <div className="profile-info-list">
          <div>
            <span>Full Name</span>
           <strong>{userData?.name || "N/A"}</strong>
          </div>

          <div>
            <span>Email Address</span>
            <strong>{userData?.email || "N/A"}</strong>
          </div>

          <div>
            <span>Phone Number</span>
            <strong>{userData?.mobile || "N/A"}</strong>
          </div>

          <div>
            <span>User ID</span>
            <strong>{userData?.referralCode || "N/A"}</strong>
          </div>
        </div>
      </section>

      <section className="profile-card">
        <div className="profile-section-title">
          <h2>Deposit History</h2>
          <button type="button">View All</button>
        </div>

        <div className="profile-history-list">
          {depositHistory.map((item, index) => (
            <article className="profile-history-item" key={`${item.date}-${index}`}>
              <div className="history-icon deposit-history-icon">↓</div>

              <div className="history-main">
                <h3>{item.amount}</h3>
                <p>
                  {item.method} • {item.date}
                </p>
              </div>

              <span className="history-status approved-status">
                {item.status}
              </span>
            </article>
          ))}
        </div>
      </section>

      <section className="profile-card">
        <div className="profile-section-title">
          <h2>Withdraw History</h2>
          <button type="button">View All</button>
        </div>

        <div className="profile-history-list">
          {withdrawHistory.map((item, index) => (
            <article className="profile-history-item" key={`${item.date}-${index}`}>
              <div className="history-icon withdraw-history-icon">↑</div>

              <div className="history-main">
                <h3>{item.amount}</h3>
                <p>
                  {item.method} • {item.date}
                </p>
              </div>

              <span
                className={`history-status ${
                  item.status === "Approved"
                    ? "approved-status"
                    : "pending-status"
                }`}
              >
                {item.status}
              </span>
            </article>
          ))}
        </div>
      </section>

      <section className="profile-card profile-actions-card">
        <button type="button" className="profile-action-button">
          🔒 Change Password
        </button>

        <button type="button" className="profile-action-button">
          🎧 Contact Support
        </button>

        <button
          type="button"
          className="profile-action-button logout-button"
         onClick={logoutUser}
        >
          🚪 Logout
        </button>
      </section>

      <nav className="bottom-nav">
      <Link to="/dashboard" className="nav-item">
          <span className="nav-icon">🏠</span>
          <span>Dashboard</span>
        </Link>

        <Link to="/deposit" className="nav-item">
          <span className="nav-icon">💰</span>
          <span>Deposit</span>
        </Link>

        <Link to="/machine" className="nav-item">
          <span className="nav-icon">▶️</span>
          <span>Machine</span>
        </Link>

        <Link to="/refer" className="nav-item">
          <span className="nav-icon">👥</span>
          <span>Referral</span>
        </Link>

        <Link to="/profile" className="nav-item active">
          <span className="nav-icon">👤</span>
          <span>Profile</span>
        </Link>
      </nav>
    </div>
  );
}

export default Profile;